// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/user/traveler.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_preferences_preferences } from "../preferences/preferences_pb";
import { file_proto_model_entity_person } from "../entity/person_pb";
import { file_proto_model_core_common } from "../core/common_pb";

/**
 * Describes the file proto/model/user/traveler.proto.
 */
export const file_proto_model_user_traveler = /*@__PURE__*/
  fileDesc("Ch9wcm90by9tb2RlbC91c2VyL3RyYXZlbGVyLnByb3RvEgZjYXJtZW4ixAIKCFRyYXZlbGVyEhMKC3RyYXZlbGVyX2lkGAEgASgJEg8KB3VzZXJfaWQYAiABKAkSFAoMZGlzcGxheV9uYW1lGAMgASgJEg0KBWVtYWlsGAQgASgJEh4KBnBlcnNvbhgFIAEoCzIOLmNhcm1lbi5QZXJzb24SKwoNdHJhdmVsZXJfdHlwZRgGIAEoDjIULmNhcm1lbi5UcmF2ZWxlclR5cGUSGwoTYXNzb2NpYXRlZF9hZHVsdF9pZBgHIAEoCRIrCgdjcmVhdGVkGAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghtb2RpZmllZBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKAoLcHJlZmVyZW5jZXMYCiABKAsyEy5jYXJtZW4uUHJlZmVyZW5jZXNCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_timestamp, file_proto_model_preferences_preferences, file_proto_model_entity_person, file_proto_model_core_common]);

/**
 * Describes the message carmen.Traveler.
 * Use `create(TravelerSchema)` to create a new message.
 */
export const TravelerSchema = /*@__PURE__*/
  messageDesc(file_proto_model_user_traveler, 0);

